module.exports = __webpack_public_path__ + "img/blank-comic-book_B0997QV49Y.8bc7f968.jpg";